export default function CollectDetail() {
    return <div>CollectDetail</div>;
}
